import request from '@/utils/request'

export function updateUserTypeCfg(data) {
  return request({
    url: 'api/v1/user-group/update',
    method: 'post',
    data: data
  })
}

export function getUserTypeList(data) {
  return request({
    url: 'api/v1/user-group/getList',
    method: 'post',
    data: data
  })
}

export function getUserTypeCfg(data) {
  return request({
    url: 'api/v1/user-group/getUserType',
    method: 'get',
    params: data
  })
}

export function getUserTypeAllList() {
  return request({
    url: 'api/v1/user-group/getGroup',
    method: 'get'
  })
}

